import GeniousCarouselTitle from './GeniusCarouselTitle';
import { connect } from './connect';

export default connect(GeniousCarouselTitle);
